import { render, staticRenderFns } from "./PushNotificationSettings.vue?vue&type=template&id=9d5fd3f2&scoped=true&"
import script from "./PushNotificationSettings.vue?vue&type=script&lang=js&"
export * from "./PushNotificationSettings.vue?vue&type=script&lang=js&"
import style0 from "./PushNotificationSettings.vue?vue&type=style&index=0&id=9d5fd3f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d5fd3f2",
  null
  
)

export default component.exports